
import { defineComponent, ref } from "vue";
import pickerPanel from "./pickerPanel";

export default defineComponent({
  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },
  setup(props, context) {
    const model = ref("");
    const pickerRef = ref({} as HTMLElement);
    const pickerPanelRef = ref();

    const show = () => {
      pickerPanelRef.value = pickerPanel({
        pickerDom: pickerRef.value,
        success: (color) => {
          model.value = color;
          context.emit("update:modelValue", model.value);
          context.emit("change", model.value);
          console.log("success回调", color, model.value);
        },
      });
    };
    return {
      model,
      show,
      pickerRef,
    };
  },
});
